export default __webpack_public_path__ + "static/19-f927c882ee3509cc8efc765f1f9f5faf.gif";